import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';

const RevenueSplineArea = ({ splineGraph }) => {
  const { country = [] } = useSelector((state) => state.country);
  let cntry = country;
  if (cntry !== 'all' && cntry !== null) {
    cntry = cntry.toUpperCase();
  }

  const options = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    xaxis: {
      type: 'date',
      categories: splineGraph?.dates,
    },
    tooltip: {
      x: {
        format: 'dd-MM-yy',
      },
    },
  };

  if (cntry === 'all' && cntry !== 'AE') {
    const series = [
      { name: 'Total AE Revenue', data: splineGraph?.total_AE_revenue },
      { name: 'Total OM Revenue', data: splineGraph?.total_OM_revenue },
      { name: 'Total QA Revenue', data: splineGraph?.total_QA_revenue },
      { name: 'Total BH Revenue', data: splineGraph?.total_BH_revenue },
    ];

    return (
      <ReactApexChart
        options={{ ...options, colors: ['#556ee6', '#34c38f', '#f1be65', '#f47f7f'] }}
        series={series}
        type="area"
        height="350"
      />
    );
  }

  const series = [{ name: 'Total Revenue', data: splineGraph?.revenue }];

  return (
    <ReactApexChart
      options={{ ...options, colors: ['#556ee6'] }}
      series={series}
      type="area"
      height="350"
    />
  );
};

export default RevenueSplineArea;
